<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
  <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm text-center">
    <h2 class="text-lg font-semibold text-gray-800">Sesión por expirar</h2>
    <p class="mt-3 text-gray-600">
      No hemos detectado actividad reciente. Tu sesión se cerrará
      automáticamente en <strong>30 segundos</strong>.
    </p>
    <div class="mt-5 flex justify-center gap-3">
      <button
        class="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg"
        (click)="continue()"
      >
        Continuar sesión
      </button>
    </div>
  </div>
</div>
